import * as React from "react";
import { lazy, Suspense } from "react";
import { Label } from "@/components/ui/label";

const Editor = lazy(() => import("@monaco-editor/react"));

interface JsonSchemaTabProps {
  parameterSchema: string;
  onSchemaChange: (value: string) => void;
}

export function JsonSchemaTab({ parameterSchema, onSchemaChange }: JsonSchemaTabProps) {
  return (
    <div className="mt-3 space-y-1.5">
      <Label htmlFor="parameterSchema" className="text-xs">Parameter Schema (JSON)</Label>
      <div className="rounded-md border overflow-hidden">
        <Suspense fallback={<div className="h-[600px] bg-muted rounded-md flex items-center justify-center text-xs text-muted-foreground">Loading editor...</div>}>
        <Editor
          height="600px"
          defaultLanguage="json"
          value={parameterSchema}
          onChange={(value) => onSchemaChange(value || "{}")}
          theme="vs-dark"
          options={{
            minimap: { enabled: false },
            fontSize: 12,
            lineNumbers: "on",
            formatOnPaste: true,
            formatOnType: true,
            automaticLayout: true,
          }}
        />
        </Suspense>
      </div>
    </div>
  );
}
